<template>
  <div id="ContactACSpage">
  
    <div class="container-fluid bg">
      <div class="row mb-2 px-3 py-3 text-white">
        <div class="col text-center mt-3 mb-5">
        <br>
        <br>
        <br>
        <br>
        <br>
          <h1>HUBUNGI KAMI</h1>
          <img src="/img/Contact_Us.png" class="img-thumbnail mb-3" />
        </div>
      </div>
      <div class="row px-3 text-white">
        <div class="col-md-6">
          <h3 class="mb-3">PLEASE SUBMIT UR INQUIRY</h3>
          <form>
            <div class="row mb-3">
              <label for="inputname" class="col-sm-2 col-form-label">
                <h3>Nama</h3>
              </label>
              <div class="col-sm-8">
                <input type="name" class="form-control" id="inputname" />
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputemail" class="col-sm-2 col-form-label">
                <h3>Email</h3>
              </label>
              <div class="col-sm-8">
                <input type="email" class="form-control" id="inputemail" />
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputphone" class="col-sm-2 col-form-label">
                <h3>Phone</h3>
              </label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="inputphone" />
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputphone" class="col-sm-2 col-form-label">
                <h5>Your Message</h5>
              </label>
              <div class="col-sm-8">
                <textarea
                  class="form-control"
                  id="FormControlTextarea1"
                  rows="9"
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-6 mt-1">
          <!-- <div class="col-xs-6 col-sm-3 col-md-6"> -->
          <div class="mapouter">
            <div class="gmap_canvas">
              <iframe
                class="rounded"
                width="100%"
                height="490"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=adofagio%20cinta%20sejati&t=&z=13&ie=UTF8&iwloc=&output=embed"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
              ></iframe>
              <!-- <p class="text-justify col-sm-6 col-md-8 ml-md-6 p-0">Graha Linesia Jalan Pisangan Timur Blok T  Pergudangan Tigaraksa Cipinang  RT 8 RW 9  Pisangan Tim Kec Pulo Gadung  Kota Jakarta Timur  Daerah Khusus Ibukota Jakarta 13230 (021) 470549</p> -->
            </div>
          </div>
          <!-- </div>  -->
        </div>
      </div>
    </div>
    <CakiACS />
  </div>
</template>

<script>
import CakiACS from "@/components/footerACS";
export default {
  name: "contactACS",

  components: {
    CakiACS,
  },
};
</script>

<style>
#ContactACSpage .bg {
  background: #1F1F1F;
}
</style>
